import styled, {ThemeProps} from 'styled-components';

import {Theme} from '@stencil/build-theme/src/types';
import {textSizes} from '@stencil/build-theme';

export const AutocompleteWrapperStyles = styled.div(
  (props: ThemeProps<Theme>) => `
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
`,
);

export const SearchInputStyles = styled.input`
  ${textSizes.MediumW2}
  background-color: ${props => props.theme.colors.goWhite.base};
  color: #222222;
  border: none;
  text-transform: capitalize;
  display: block;
  width: 100%;
  height: 4.2rem;
  padding: ${props => props.theme.spacing.base} ${props => props.theme.spacing.base}
    ${props => props.theme.spacing.custom(12)} ${props => props.theme.spacing.base};
  border-radius: ${props => props.theme.misc.borderRadius.xlarge};
  flex-direction: row;
  align-items: center;
  justify-conent: center;
  &::-webkit-input-placeholder {
    color: white;
    opacity: 0.5;
    ${textSizes.MediumW2}
  }
  &:focus {
    box-shadow: none;
    outline: none;
  }
`;

export const SearchLabelStyles = styled.label`
  ${textSizes.SmallW1}
  color: ${props => props.theme.colors.goWhite.base};
  padding-bottom: ${props => props.theme.spacing.small};
  padding-left: ${props => props.theme.spacing.custom(2)};
`;
